/**
 * Created by andrey on 26.01.2026
 */

const LocationsClientValidator = {
    validate: function () {
        if (cleverapps.config.name === "map2deditor") {
            return;
        }

        cleverapps.whenAllInitialized(() => {
            Object.values(cleverapps.meta.locations).forEach((locationMeta) => this.validateLocation(locationMeta));
        });
    },

    validateDialogues: function (location) {
        const locationId = location.locationId;
        const missing = {};

        const validatePerson = (person, source) => {
            if (!person) {
                return;
            }

            if (typeof person === "string") {
                person = { role: person };
            }

            const emotion = person.emotion || "idle";
            const personData = cleverapps.persons.getRole(person.role);
            if (!personData || !personData.json || !cleverapps.bundleLoader.isLoaded(personData.bundle)) {
                return;
            }

            if (!cleverapps.Spine.hasAnimation(emotion, personData.json)) {
                const key = `"${person.role}" missing "${emotion}"`;
                if (!missing[key]) {
                    missing[key] = { count: 0, source };
                }
                missing[key].count++;
            }
        };

        const validateSteps = (steps, source) => {
            if (!Array.isArray(steps)) {
                return;
            }

            steps.forEach((step) => {
                validatePerson(step.person, source);
                validatePerson(step.person2, source);
            });
        };

        const storyBundleName = `unitstories_${locationId}`;
        const storyBundle = bundles[storyBundleName];
        if (storyBundle && storyBundle.jsons.unitstories_json) {
            const stories = storyBundle.jsons.unitstories_json.resolve().getJson();
            Object.keys(stories).forEach((key) => {
                if (key !== "__meta__" && stories[key] && stories[key].dialogue) {
                    validateSteps(stories[key].dialogue, `unitStories/${locationId}/${key}`);
                }
            });
        }

        let questBundleName = `quests_${locationId}`;
        let questBundle = bundles[questBundleName];
        if (!questBundle || !questBundle.jsons.quests_json) {
            questBundleName = `quests_${location.meta && location.meta.units}`;
            questBundle = bundles[questBundleName];
        }
        if (questBundle && questBundle.jsons.quests_json) {
            const quests = questBundle.jsons.quests_json.resolve().getJson();
            Object.keys(quests).forEach((key) => {
                if (key !== "__meta__" && quests[key] && quests[key].dialogue) {
                    validateSteps(quests[key].dialogue, `quests/${locationId}/${key}`);
                }
            });
        }

        if (bundles.repair_dialogues && bundles.repair_dialogues.jsons.repair_dialogues_data_json) {
            const roomRepair = bundles.repair_dialogues.jsons.repair_dialogues_data_json.resolve().getJson();
            Object.keys(roomRepair).forEach((key) => {
                if (roomRepair[key] && roomRepair[key].dialogue) {
                    validateSteps(roomRepair[key].dialogue, `roomRepair/${key}`);
                }
            });
        }

        const keys = Object.keys(missing);
        if (keys.length) {
            const lines = keys.map((key) => `${key} (x${missing[key].count}, e.g. ${missing[key].source})`);
            cleverapps.throwAsync(`Missing dialogue animations (${locationId}):\n${lines.join("\n")}`);
        }
    },

    validateLocation: function (locationMeta) {
        const locationId = locationMeta.locationId;
        const locationConfig = locationMeta.locationConfig;

        if (locationConfig.unknown === true) {
            return;
        }

        if (locationConfig.retire === undefined) {
            cleverapps.throwAsync(`${locationId} must have retire date`);
            return;
        }

        if (locationConfig.schedule) {
            const finishTime = cleverapps.convertToTimezone(locationConfig.schedule.finish).getTime();
            const retireTime = locationConfig.retire ? new Date(locationConfig.retire).getTime() : 0;

            const timeout = cleverapps.parseInterval("1 month");

            if (finishTime && (retireTime < finishTime || retireTime > finishTime + timeout)) {
                const start = new Date(finishTime).toLocaleDateString();
                const end = new Date(finishTime + timeout).toLocaleDateString();
                cleverapps.throwAsync(`${locationId} must have retire date between ${start} and ${end}`);
            }
        }
    }
};